window.GIFTBOX_CUSTOM_UPDATE_CART = () => {
document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
bubbles: true // same code for prestige theme

}));
}

window.GIFTBOX_CUSTOM_CART_ITEMS_SELECTORS = [".cart-page table.order-summary .order-summary__body tr"];
window.GIFTBOX_CUSTOM_CART_REMOVE_INPUTS_SELECTORS = ["a.quantity-selector__button, .quantity-selector "];



    const gbInt = setInterval(()=>{

        const freeGiftsGrid=document.querySelectorAll(".line-item-info a.h6[href*='free-gift']") // pay attention to the target of this example
        
        if (freeGiftsGrid.length) {
            freeGiftsGrid.forEach(g=>{
                const a = g.closest('.line-item-info')?.querySelector('.quantity-selector')
                
                a.style.opacity = "0.25"
                a.style.pointerEvents = "none"

                const b = g.closest('.line-item-info')?.querySelectorAll('.quantity-selector *')
                b?.forEach(t=> {
                    t.style.opacity = "0.25"
                    t.style.pointerEvents = "none"
                });
            }
            )
        }
        }
        , 50)